import axios, {AxiosError} from "axios";
import {throwErrorForCode} from "@/errors/errors";

export default async function serve(fun: () => any) {
    try {
        const res = await fun()
        return res.data
    } catch (err) {
        if (axios.isAxiosError(err)) throwErrorForCode(err as AxiosError)
        else throw err
    }
}